// ARC -- the SYSTEM LANGUAGE of Martian: architecture, workflows,
// relationships. It is NEVER an app icon, favicon, avatar, mascot or a
// competing hero (see public/brand/arc/NO_PRIMARY_ICON.md). Minimum 32 px:
// below that the mark is not drawn (ARC is not forced where unreadable).

import { ARC_ASSETS, ARC_MIN_PX } from './assets';
import './brand.css';

const TONE_SRC = {
  clay: ARC_ASSETS.master,
  'cream-on-ink': ARC_ASSETS.creamOnInk,
  'mono-ink': ARC_ASSETS.monoInk,
  'mono-paper': ARC_ASSETS.monoPaper,
};

export function ARC({ size = 64, tone = 'clay', decorative = true, label = 'Martian ARC system mark', className = '', ...rest }) {
  if (size < ARC_MIN_PX) return null;
  return (
    <img
      src={TONE_SRC[tone] || ARC_ASSETS.master}
      width={size}
      height={size}
      alt={decorative ? '' : label}
      aria-hidden={decorative ? 'true' : undefined}
      draggable={false}
      className={`arc-mark ${className}`.trim()}
      data-testid="arc"
      {...rest}
    />
  );
}

export default ARC;
